<template>
  <div class="work-component-block">
    <!-- Main components -->

    <TopMenu></TopMenu>
    <SideMenu></SideMenu>
    <ContentContainer></ContentContainer>

    <!-- Overlay modal windows -->
    <RendersPreviewWindow
      v-show="this.$store.getters.showRendersPreviewWindow"
      @close="onCloseRendersPreviewWindow"
    ></RendersPreviewWindow>

    <MusicLibraryWindow
      v-if="this.$store.getters.showMusicLibraryWindow"
      @close="onCloseMusicLibraryWindow"
      :isLoading="isLoadingMusicLibrary"
    ></MusicLibraryWindow>

    <EndCardLibraryWindow
      v-if="this.$store.getters.showEndCardLibraryWindow"
      @close="onCloseEndCardLibraryWindow"
    ></EndCardLibraryWindow>

    <EndCardEditWindow
      v-if="this.$store.getters.showEndCardEditWindow"
      :packshot="packshotToEdit"
      @close="onCloseEndCardEditWindow"
    ></EndCardEditWindow>

    <OverlaysLibraryWindow
      v-if="this.$store.getters.showOverlaysLibraryWindow"
      @close="onCloseOverlaysLibraryWindow"
      :isLoading="isLoadingOverlaysLibrary"
    ></OverlaysLibraryWindow>

    <EndCardCropImageWindow
      v-if="this.$store.getters.showEndCardCropImageWindow"
	  @close="onCloseEndCardCropImage"
      :isLoading="isLoadingOverlaysLibrary"
    ></EndCardCropImageWindow>

    <!--     <BaseConfirm
      v-if="isSessionConflict"
      :title="'Notification'"
      :message="'New session is available. Update?'"
      @accept="reloadPage"
      @discard="
        () => {
          this.saveUserWorkspace(true);
          this.isSessionConflict = false;
        }
      "
    >
    </BaseConfirm> -->

    <BaseConfirm
      v-if="confirmWindowParameters.isShow && !confirmWindowParameters.isInline"
      :title="confirmWindowParameters.title"
      :message="confirmWindowParameters.message"
      :description="confirmWindowParameters.description"
      :acceptTitle="confirmWindowParameters.acceptTitle"
      :discardTitle="confirmWindowParameters.discardTitle"
      @accept="confirmWindowParameters.acceptCallback"
      @discard="confirmWindowParameters.discardCallback"
      @close="onCloseConfirmWindow"
    >
    </BaseConfirm>

    <BaseConfirmInline
      v-if="confirmWindowParameters.isShow && confirmWindowParameters.isInline"
      :message="confirmWindowParameters.message"
      :acceptTitle="confirmWindowParameters.acceptTitle"
      :discardTitle="confirmWindowParameters.discardTitle"
      :needCloseClickOutside="confirmWindowParameters.needCloseClickOutside"
      @accept="confirmWindowParameters.acceptCallback"
      @discard="confirmWindowParameters.discardCallback"
      @close="onCloseConfirmWindow"
    >
    </BaseConfirmInline>
  </div>
</template>

<script>
import "@/app/store/index";
import { $eventsBus } from "@/main";
import TopMenu from "@/app/modules/work/components/TheTopMenu";
import SideMenu from "@/app/modules/work/components/TheSideMenu";
import ContentContainer from "@/app/modules/work/components/content-cotainer/TheContentContainer";
import RendersPreviewWindow from "@/app/modules/work/components/windows/RendersPreviewWindow";
import MusicLibraryWindow from "@/app/modules/work/components/windows/MusicLibraryWindow";
import EndCardLibraryWindow from "@/app/modules/work/components/windows/EndCardLibraryWindow";
import EndCardEditWindow from "@/app/modules/work/components/windows/EndCardEditWindow";
import OverlaysLibraryWindow from "@/app/modules/work/components/windows/OverlaysLibraryWindow";
import EndCardCropImageWindow from "@/app/modules/work/components/windows/EndCardCropImageWindow";
import BaseConfirm from "@/app/shared/components/base/BaseConfirm.vue";
import BaseConfirmInline from "@/app/shared/components/base/BaseConfirmInline.vue";
import _ from "lodash";
import { parseStoreStateToWorkspaceSnapshot } from "@/app/shared/utils/utils.js";

export default {
  name: "Work",
  components: {
    TopMenu,
    SideMenu,
    ContentContainer,
    RendersPreviewWindow,
    MusicLibraryWindow,
    EndCardLibraryWindow,
    EndCardEditWindow,
    OverlaysLibraryWindow,
    EndCardCropImageWindow,
    BaseConfirm,
    BaseConfirmInline,
  },
  data: function () {
    return {
      savingInProgress: false,
      packshotToEdit: null,
      requestSavingTimer: null,
      isLoadingOverlaysLibrary: true,
      isLoadingMusicLibrary: true,
      isSessionConflict: false,
      confirmWindowParameters: {
        isShow: false,
        isInline: false,
        title: "",
        message: "",
        description: "",
        acceptTitle: "Yes",
        discardTitle: "No",
        acceptCallback: () => {},
        discardCallback: () => {},
        needCloseClickOutside: true,
      },
    };
  },
  computed: {
    snapshot: {
      get() {
        return this.$store.state.snapshot;
      },
      set(currentState) {
        this.$store.commit("setSnapshot", currentState);
      },
    },
  },
  mounted() {
    this.getUser().then((response) => {
      if (response.isResolve) {
        this.requestSaving();

        // TODO test yandex metrik
        try {
          if (this.$metrika) {
            this.$metrika.userParams({
              Авторизация: response.userId,
            });
          }
        } catch (e) {
          console.error(e);
        }
      }
    });
    this.updateOverlaysLibrary();
    this.updateMusicLibrary();
  },
  created() {
    $eventsBus.$on("saveUserWorkspace", (isForceSaving) => {
      this.saveUserWorkspace(isForceSaving);
    });
    $eventsBus.$on("updateUserWorkspace", (workspace) => {
      if (!workspace) {
        return;
      }
      let state = workspace;
      this.$store.commit("updateStateByUserWorkspace", state);
      $eventsBus.$emit("updateAllMoveables");
    });
    $eventsBus.$on("openEndCardEditWindow", (endCardToEdit) => {
      this.packshotToEdit = endCardToEdit;
      this.$store.commit("showEndCardEditWindow", true);
      this.$store.commit("showEndCardLibraryWindow", false);
    });
    $eventsBus.$on("openConfirmWindow", (params) => {
      const {
        isInline,
        title,
        message,
        description,
        acceptTitle,
        discardTitle,
        acceptCallback,
        discardCallback,
        needCloseClickOutside,
      } = params;
      this.confirmWindowParameters.isShow = true;
      this.confirmWindowParameters.isInline = !!isInline;
      this.confirmWindowParameters.title = !!title ? title : "";
      this.confirmWindowParameters.message = !!message ? message : "";
      this.confirmWindowParameters.description = !!description
        ? description
        : "";
      this.confirmWindowParameters.acceptTitle = !!acceptTitle
        ? acceptTitle
        : "Yes";
      this.confirmWindowParameters.discardTitle = !!discardTitle
        ? discardTitle
        : "No";
      this.confirmWindowParameters.acceptCallback = !!acceptCallback
        ? acceptCallback
        : () => {};
      this.confirmWindowParameters.discardCallback = !!discardCallback
        ? discardCallback
        : () => {};
      this.confirmWindowParameters.needCloseClickOutside =
        needCloseClickOutside;
    });
  },
  beforeDestroy() {
    clearInterval(this.requestSavingTimer);
  },
  methods: {
    reloadPage() {
      location.reload();
    },
    async getUser() {
      if (this.$store.getters.isLoggedIn) {
        this.checkUATasksInCookies();

        let ymUID = this.$cookies.get("_ym_uid");
        return await this.axios
          .post(
            "/user/getUser",
            { sessionId: this.$store.state.userInfo.sessionId, ymUID: ymUID },
            {
              headers: {
                Accept: "application/json",
                "Content-Type": "application/json",
              },
            }
          )
          .then((response) => {
            this.$store.state.userInfo.id = response.data.id;
            this.$store.state.userInfo.firstName = response.data.firstName;
            this.$store.state.userInfo.lastName = response.data.lastName;
            this.$store.state.userInfo.avatar = response.data.avatar;
            this.$store.state.userInfo.stockAccess = response.data.stockAccess;
            this.$store.state.userInfo.isInHouse = response.data.roasupUser;
            this.$store.state.userInfo.isSaveOriginalName =
              response.data.originalName;
            this.$store.state.userInfo.lastWorkspaceSaveTime =
              response.data.lastSaveWS;
            if (this.$router.history.current.path !== "/") {
              this.$router.push("/");
            }
            $eventsBus.$emit("updateUserWorkspace", response.data.workspace);

            const currentState = _.cloneDeep(
              parseStoreStateToWorkspaceSnapshot(this.$store.state)
            );
            this.snapshot = currentState;

            return { isResolve: true, userId: response.data.id };
          })
          .catch((erorr) => {
            console.error(erorr);
            this.$store.state.userInfo.sessionId = null;
            this.$router.push("/login");

            return { isResolve: false };
          });
      }
    },
    onCloseRendersPreviewWindow() {
      this.$store.commit("showRendersPreviewWindow", false);
      $eventsBus.$emit("updateYandexHitByOpenedTool");
    },
    onCloseMusicLibraryWindow() {
      this.$store.commit("showMusicLibraryWindow", false);
    },
    onCloseEndCardLibraryWindow() {
      this.$store.commit("showEndCardLibraryWindow", false);
    },
    onCloseEndCardEditWindow() {
      this.$store.commit("showEndCardEditWindow", false);
      this.$store.commit("showEndCardLibraryWindow", true);
    },
    onCloseStickerLibraryWindow() {
      this.$store.commit("showStickerLibraryWindow", false);
    },
    onCloseOverlaysLibraryWindow() {
      this.$store.commit("showOverlaysLibraryWindow", false);
    },
    onCloseEndCardCropImage() {
      this.$store.commit("showEndCardCropImageWindow", false);
    },
    onCloseConfirmWindow() {
      this.confirmWindowParameters.isShow = false;
    },
    checkServerWorkspaceChangesAndSave() {
      let ymUID = this.$cookies.get("_ym_uid");
      this.axios
        .post(
          "/user/getUser",
          { sessionId: this.$store.state.userInfo.sessionId, ymUID: ymUID },
          {
            headers: {
              Accept: "application/json",
              "Content-Type": "application/json",
            },
          }
        )
        .then((response) => {
          const currentState = _.cloneDeep(
            parseStoreStateToWorkspaceSnapshot(this.$store.state)
          );

          if (
            this.$store.state.userInfo.lastWorkspaceSaveTime &&
            response.data.lastSaveWS - this.$store.state.userInfo.lastWorkspaceSaveTime > 10
          ) {
            if (!_.isEqual(response.data.workspace, currentState)) {
              clearInterval(this.requestSavingTimer);
              //this.isSessionConflict = true;
              $eventsBus.$emit("openConfirmWindow", {
                title: "Notification",
                message: "New session is available. Update?",
                acceptCallback: this.reloadPage,
                discardCallback: this.saveUserWorkspace.bind(true),
              });
            }
          } else {
            if (!_.isEqual(response.data.workspace, currentState)) {
              this.saveUserWorkspace();
            }
          }
        })
        .catch((error) => {
          console.error(error);
          this.$store.state.userInfo.sessionId = null;
          this.$router.push("/login");
        });
    },
    requestSaving() {
      if (this.savingInProgress) {
        setTimeout(() => {
          this.requestSaving();
        }, 1000);
      } else {
        this.checkServerWorkspaceChangesAndSave();
      }
    },
    saveUserWorkspace(isForceSaving = false) {
      const currentState = _.cloneDeep(
        parseStoreStateToWorkspaceSnapshot(this.$store.state)
      );

      if (!isForceSaving) {
        this.savingInProgress = true;
        // Сохранение происходит:
        // - Каждые 30 секунд
        // - При каждом удалении, добавлении, восстановлении файлов или вариаций
        // - При каждой отправке на рендер и изменении в боковой панели рендера
        console.log("Save workspace");

        if (_.isEqual(this.snapshot, currentState)) {
          console.log("No need to save workspace");
          this.savingInProgress = false;
          clearInterval(this.requestSavingTimer);
          this.requestSavingTimer = setInterval(() => {
            this.requestSaving();
          }, 30000);
          return;
        }
      }
      //cache = null;
      this.axios
        .post(
          "/user/setWorkspace",
          {
            sessionId: this.$store.state.userInfo.sessionId,
            workspace: currentState,
          },
          {
            headers: {
              Accept: "application/json",
              "Content-Type": "application/json",
            },
          }
        )
        .then((response) => {
          console.log("Workspace saved");
          this.$store.state.userInfo.lastWorkspaceSaveTime =
            response.data.currentTime;
        })
        .catch((error) => {
          console.error(error);
          console.log("Workspace not saved");
        })
        .finally(() => {
          this.savingInProgress = false;
          clearInterval(this.requestSavingTimer);
          this.requestSavingTimer = setInterval(() => {
            this.requestSaving();
          }, 30000);
          this.snapshot = currentState;
        });
    },
    checkUATasksInCookies() {
      let uaCreativeTasksIds = this.$cookies.get("uaCreativeTasksIds");
      uaCreativeTasksIds = uaCreativeTasksIds
        ? JSON.parse(uaCreativeTasksIds)
        : [];
      if (uaCreativeTasksIds.length !== 0) {
        console.log(uaCreativeTasksIds.length + " UA Tasks to import");
        this.$store.commit("updateTasksFromUAToUpload", uaCreativeTasksIds);
        uaCreativeTasksIds.forEach((taskId) => {
          this.imortUAItems(taskId);
        });
      }
    },
    imortUAItems(taskId) {
      this.axios
        .post(
          "/uploads/getFilesFromUA",
          {
            sessionId: this.$store.state.userInfo.sessionId,
            hash: taskId,
          },
          {
            headers: {
              Accept: "application/json",
              "Content-Type": "application/json",
            },
          }
        )
        .then((res) => {
          if (res.data.length !== 0) {
            this.$store.commit("itemsUploaded", res.data);
            $eventsBus.$emit("saveUserWorkspace");
            this.$store.commit("addNewStateToHistory");
          }
        })
        .catch((erorr) => {
          console.error(erorr);
        })
        .finally(() => {
          let uaCreativeTasksIds = this.$cookies.get("uaCreativeTasksIds");
          uaCreativeTasksIds = uaCreativeTasksIds
            ? JSON.parse(uaCreativeTasksIds)
            : [];

          if (uaCreativeTasksIds.length !== 0) {
            let filteredTasksIds = uaCreativeTasksIds.filter(
              (t) => t !== taskId
            );
            this.$store.commit("updateTasksFromUAToUpload", filteredTasksIds);
            this.$cookies.set(
              "uaCreativeTasksIds",
              JSON.stringify(filteredTasksIds)
            );
          }
        });
    },
    updateOverlaysLibrary() {
      this.axios
        .post(
          "/overlays/getItems",
          {
            sessionId: this.$store.state.userInfo.sessionId,
            name: "",
          },
          {
            headers: {
              Accept: "application/json",
              "Content-Type": "application/json",
            },
          }
        )
        .then((response) => {
          response.data.forEach((file) => {
            if (file.type === "video" || file.type === "gif") {
              this.$store.commit("pushVideoToOverlaysLibrary", {
                ...file,
                isPlug: true,
              });
            } else if (file.type === "image") {
              this.$store.commit("pushImageToOverlaysLibrary", {
                ...file,
                isPlug: true,
              });
            } else {
              this.$store.commit("pushShapeToOverlaysLibrary", file);
            }
          });
        })
        .finally(() => {
          this.isLoadingOverlaysLibrary = false;
        });
    },
    updateMusicLibrary() {
      this.axios
        .post(
          "/audio/getMusic",
          {
            sessionId: this.$store.state.userInfo.sessionId,
          },
          {
            headers: {
              Accept: "application/json",
              "Content-Type": "application/json",
            },
          }
        )
        .then((response) => {
          this.files = [];
          response.data.forEach((file) => {
            this.$store.commit("pushFileToMusicLibrary", {
              duration: file.duration,
              path: file.path,
              id: file.id,
              name: file.name,
            });
          });
        })
        .finally(() => {
          this.isLoadingMusicLibrary = false;
        });
    },
  },
};
</script>

<style lang="scss">
.work-component-block {
  position: relative;
  width: 100%;
  height: 100%;
}
</style>
